import { Injectable, OnDestroy } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router'
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular'
import { Subject, Subscription } from 'rxjs'
import { AppUserRoleEnum } from '../models/enums/app-user-role.enum'

@Injectable({
   providedIn: 'root'
})
export class AppAuthService implements CanActivate, OnDestroy {
   licenceSubject$: Subject<boolean> = new Subject<boolean>()
   console: boolean = false
   logPrefix: string = '@AppAuthService - ' + this.constructor.name

   public appRoles: any = {}

   private keycloakEventsSubscription: Subscription

   constructor(public keycloakAngular: KeycloakService) {
      this.keycloakEventsSubscription = keycloakAngular.keycloakEvents$.subscribe({
         next: (event) => {
            switch (event.type) {
               case KeycloakEventTypeLegacy.OnAuthError:
                  this.keycloakEventLog(event.type)
                  break
               case KeycloakEventTypeLegacy.OnAuthLogout:
                  this.keycloakEventLog(event.type)
                  void this.keycloakAngular.logout()
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshError:
                  this.keycloakEventLog(event.type)
                  void this.keycloakAngular.login()
                  break
               case KeycloakEventTypeLegacy.OnAuthRefreshSuccess:
                  this.keycloakEventLog(event.type)
                  this.licenceSubject$.next(this.hasLicence())
                  break
               case KeycloakEventTypeLegacy.OnAuthSuccess:
               case KeycloakEventTypeLegacy.OnReady:
                  this.keycloakEventLog(event.type)
                  break
               case KeycloakEventTypeLegacy.OnTokenExpired:
                  this.keycloakEventLog(event.type)
                  void this.keycloakAngular.updateToken(5)
                  break
               default:
                  break
            }
         }
      })
   }

   ngOnDestroy(): void {
      this.keycloakEventsSubscription.unsubscribe()
   }

   hasLicence(): boolean {
      const roles = this.keycloakAngular.getUserRoles(true)
      return roles.includes('LICENCE_PMP_TOOL_ADMIN') || roles.includes('LICENCE_PMP_TOOL_BASE')
   }

   async retriveRole(): Promise<AppUserRoleEnum | undefined> {
      const roles = this.keycloakAngular.getUserRoles(true)
      if (roles.includes('LICENCE_PMP_TOOL_ADMIN')) return AppUserRoleEnum.ADMIN
      if (roles.includes('LICENCE_PMP_TOOL_BASE')) return AppUserRoleEnum.BASE
      return
   }

   async isUserLogged(): Promise<boolean> {
      return this.keycloakAngular.isLoggedIn()
   }

   async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
      if (this.console) console.log(this.logPrefix, 'canActivate')
      if (!this.keycloakAngular.isLoggedIn()) {
         if (this.console) console.log(this.logPrefix, 'no allowed')
         await this.keycloakAngular.login({ redirectUri: window.location.origin + state.url }).catch((error) => console.error(error))
         return false
      }
      return true
   }

   logout(): void {
      void this.keycloakAngular.logout()
   }

   private keycloakEventLog(type: KeycloakEventTypeLegacy): void {
      if (this.console) console.log(this.logPrefix, 'Keycloak event - Type: ' + KeycloakEventTypeLegacy[type])
   }
}
